// extracted by mini-css-extract-plugin
module.exports = {"row":"statusUpdates__row--1F7aE","message":"statusUpdates__message--2H4N7"};